import {
  getUsersByGroup,
  ioCompanyAddUserToGroup,
  ioCompanyCreateGroup,
  ioCompanyDeleteUsersGroup,
  ioCompanyGetSubstitute,
  ioCompanyGroups,
  ioCompanyList,
  ioCompanyMarkLider,
  ioCompanyRemoveGroup,
  ioCompanyUpdateGroup,
  ioCompanyUpdateUsersGroup,
  ioCompanyUserSubstitute,
  ioGetCompanyBranchesV2,
  signsUser
} from '@/febos/servicios/api/empresas.api';
import { getUsers } from '@/febos/servicios/api/usuarios.api';
import {
  ioListConfigurations,
  ioListOptions,
  ioListRateOfExchange,
  ioSaveConfiguration, ioSaveParameter
} from '@/febos/servicios/api/herramientas.api';
import store from '@/store/store';
import { fileBinnacle } from '@/febos/servicios/api/dnt.api';
import { ioGetSettings } from '@/febos/servicios/api/configuraciones.api';

export default {
  async loadCompanies({ commit }, payload) {
    try {
      const response = await ioCompanyList(
        payload.pagina,
        payload.filas,
        payload.busquedaSimple,
        `${process.env.VUE_APP_PORTAL}`,
        window.location.hostname
      );

      if (response.data.codigo !== 10) throw response.data;
      commit('SET_LISTADO_EMPRESAS', response.data);
      return response.data;
    } catch (error) {
      console.log('ERROR', error);
      return error;
    }
  },
  // TODO: change name to update
  async selectCompany({ commit }, payload) {
    await commit('SET_EMPRESA', payload);
  },
  async getUsersCompany({ commit, state }, payload) {
    try {
      commit('SET_LOADING', true);
      commit('SET_USERS_COMPANY', {
        usuarios: [],
        totalElementos: state?.pagination?.items || 0,
        totalPaginas: state?.pagination?.pages || 0
      });
      const response = await getUsers(payload);
      commit('SET_USERS_COMPANY', response.data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getUsersCompanyToAssign({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await getUsers(payload);
      commit('SET_USERS_COMPANY_ASSIGN', response.data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getGroupsCompany({ commit }, payload) {
    commit('SET_GROUPS_COMPANY', []);
    const response = await ioCompanyGroups(payload);
    commit('SET_GROUPS_COMPANY', response.data.grupos);
  },
  async loadConfigurations({ commit }, payload = {}) {
    commit('SET_LOAD_CONFIGURATIONS', true);
    try {
      const response = await ioListConfigurations(payload);
      commit('SET_CONFIGURATIONS', response.data.configuraciones);
    } finally {
      commit('SET_LOAD_CONFIGURATIONS', false);
    }
  },
  async saveConfiguration({ commit }, requestParams = {
    params: {},
    body: {}
  }) {
    commit('SET_SAVING_CONFIGURATIONS', true);
    try {
      return await ioSaveConfiguration(requestParams.params, requestParams.body);
    } finally {
      commit('SET_SAVING_CONFIGURATIONS', false);
    }
  },
  async saveParameter({ commit }, requestParams = {
    params: {},
    body: {}
  }) {
    commit('SET_SAVING_CONFIGURATIONS', true);
    try {
      return await ioSaveParameter(requestParams.params, requestParams.body);
    } finally {
      commit('SET_SAVING_CONFIGURATIONS', false);
    }
  },
  async getUsersGroup({ commit, state }, payload) {
    try {
      commit('SET_USERS_GROUP', {
        usuarios: [],
        totalElementos: state?.pagination?.items || 0,
        totalPaginas: state?.pagination?.pages || 0
      });
      commit('SET_LOADING', true);
      const response = await getUsersByGroup(payload);
      commit('SET_USERS_GROUP', response.data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateGroup({ commit }, {
    empresaId,
    group
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyUpdateGroup(empresaId, group);
      commit('UPDATE_GROUP', group);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async createGroup({ commit }, {
    empresaId,
    group
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyCreateGroup(empresaId, group);
      commit('ADD_GROUP', response.data.grupo);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async removeGroupCompany({ commit }, {
    empresaIut,
    groupId
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyRemoveGroup(empresaIut, groupId);
      commit('REMOVE_GROUP', groupId);
      commit('SET_LOADING', false);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addUserToGroup({ commit }, {
    empresaId,
    body
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyUpdateUsersGroup(empresaId,
        {
          grupoId: body.grupoId,
          usuarios: body.usuarios
        });
      commit('ADD_USER_GROUP', body.user);
      // store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addUserToGroupV2({ commit }, {
    companyId,
    groupId,
    userId,
    isLider
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyAddUserToGroup(companyId,
        {
          groupId,
          userId,
          isLider
        });
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getBinnacle({ commit }, userId) {
    try {
      commit('SET_LOADING', true);
      const response = await fileBinnacle({ febosId: userId });
      commit('SET_LOADING', false);
      return response.data.bitacora;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async markLiderInGroup({ commit }, {
    empresaId,
    body
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyMarkLider(empresaId, body);
      commit('SET_LIDER_GROUP', body);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async removeUserToGroup({ commit }, {
    empresaId,
    grupoId,
    usuarioId,
    user
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyDeleteUsersGroup(empresaId, grupoId, usuarioId);
      commit('REMOVE_USER_GROUP', user);
      // store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addSubstituteUser({ commit }, {
    empresaId,
    substitute
  }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCompanyUserSubstitute(empresaId, substitute);
      commit('SET_SUCCESS_MESSAGE', true);
      commit('SAVE_SUBSTITUTE_USER', response.data.remplazo);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getSubstituteUser({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      if (!payload.preserve) {
        commit('SET_SUBSTITUTES_USER', []);
      }
      const response = await ioCompanyGetSubstitute(payload);
      commit('SET_SUBSTITUTES_USER', response.data.usuarios);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getUserSigns({ commit }, companyIut) {
    const response = await signsUser(companyIut);
    commit('SET_USER_SIGN', response.data);
    return response.data;
  },
  async fetchCompanyBranches({ commit }, {
    iut,
    filter,
    page,
    limit,
    order
  }) {
    commit('SET_LIST_LOADING', {
      target: 'branches',
      company: iut,
      value: true
    });
    try {
      const { data: { sucursales: branches } } = await ioGetCompanyBranchesV2(
        {
          iut,
          filter,
          page,
          limit,
          order
        }
      );
      commit('SET_LIST', {
        target: 'branches',
        company: iut,
        value: branches
      });
    } catch (e) {
      console.error(e);
    } finally {
      commit('SET_LIST_LOADING', {
        target: 'branches',
        company: iut,
        value: false
      });
    }
  },
  async fetchCompanyOptions({ commit }, {
    iut,
    grupoOpcion,
    filter
  }) {
    commit('SET_LIST_LOADING', {
      target: `options-${grupoOpcion}`,
      company: iut,
      value: true
    });
    const { data: { opciones } } = await ioListOptions({
      grupoOpcion,
      filtros: filter
    });
    commit('SET_LIST', {
      target: `options-${grupoOpcion}`,
      company: iut,
      value: opciones
    });
    commit('SET_LIST_LOADING', {
      target: `options-${grupoOpcion}`,
      company: iut,
      value: false
    });
    return opciones;
  },
  async fetchCompanyRateOfExchange({ commit }, {
    iut,
    fecha,
    pagina,
    itemsPorPagina
  }) {
    commit('SET_LIST_LOADING', {
      target: 'rate-exchange',
      company: iut,
      value: true
    });
    const { data: { elementos } } = await ioListRateOfExchange({
      iut,
      fecha,
      pagina,
      itemsPorPagina
    });
    commit('SET_LIST', {
      target: 'rate-exchange',
      company: iut,
      value: elementos
    });
    commit('SET_LIST_LOADING', {
      target: 'rate-exchange',
      company: iut,
      value: false
    });
    return elementos;
  },
  async fetchCompanySetting({ commit }, { parameters = [] }) {
    commit('SET_SETTINGS_LOADING', true);
    try {
      const { data: { configuraciones } } = await ioGetSettings({ parameters });
      commit('SET_SETTINGS', { settings: configuraciones });
      return configuraciones;
    } finally {
      commit('SET_SETTINGS_LOADING', false);
    }
  },
  async setDomainCompany({ commit }, company) {
    commit('SET_DOMAIN_COMPANY', company);
  },
};
